import React from 'react';
import { useLanguage } from '../../context/LanguageContext';

export const NarrativeSection = () => {
  const { t } = useLanguage();

  return (
    <section
      data-testid="narrative-section"
      className="py-24 md:py-32 bg-white relative overflow-hidden"
    >
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-oar-green-soft to-transparent" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-4xl">
          {/* Tricolor accent */}
          <div className="flex gap-1 mb-8">
            <div className="w-8 h-1 bg-white rounded-full" />
            <div className="w-8 h-1 bg-oar-blue rounded-full" />
            <div className="w-8 h-1 bg-oar-red rounded-full" />
          </div>

          <h2
            data-testid="narrative-title"
            className="font-heading text-3xl md:text-5xl font-semibold tracking-tight text-oar-text-primary mb-8"
          >
            {t('narrative.title')}
          </h2>

          <p className="text-lg md:text-xl text-oar-text-secondary leading-relaxed font-light">
            {t('narrative.text')}
          </p>

          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mt-16">
            <div className="text-center md:text-left">
              <div className="text-4xl md:text-5xl font-heading font-bold text-oar-blue">25+</div>
              <div className="text-sm text-oar-text-muted uppercase tracking-wider mt-2">Pays Membres</div>
            </div>
            <div className="text-center md:text-left">
              <div className="text-4xl md:text-5xl font-heading font-bold text-oar-red">50+</div>
              <div className="text-sm text-oar-text-muted uppercase tracking-wider mt-2">Universités</div>
            </div>
            <div className="text-center md:text-left">
              <div className="text-4xl md:text-5xl font-heading font-bold text-oar-green">10K+</div>
              <div className="text-sm text-oar-text-muted uppercase tracking-wider mt-2">Étudiants</div>
            </div>
            <div className="text-center md:text-left">
              <div className="text-4xl md:text-5xl font-heading font-bold text-oar-orange">2022</div>
              <div className="text-sm text-oar-text-muted uppercase tracking-wider mt-2">Fondation</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
